import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video"];
  static values = {
    loopDelay: { type: Number, default: 0 },
  };

  connect() {
    this.inViewport = false;
    this.loopTimer = null;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.inViewport = entry.isIntersecting;
        if (this.inViewport) {
          this.videoTarget.play().catch(() => {});
        } else {
          this.videoTarget.pause();
          clearTimeout(this.loopTimer);
        }
      },
      { threshold: 0.1 },
    );

    this.observer.observe(this.element);

    if (this.loopDelayValue > 0) {
      this.videoTarget.addEventListener("ended", this.handleEnded);
    }
  }

  handleEnded = () => {
    if (!this.inViewport) {
      return;
    }

    this.loopTimer = setTimeout(() => {
      if (this.inViewport) {
        this.videoTarget.currentTime = 0;
        this.videoTarget.play().catch(() => {});
      }
    }, this.loopDelayValue);
  };

  disconnect() {
    this.observer.disconnect();
    clearTimeout(this.loopTimer);

    if (this.loopDelayValue > 0) {
      this.videoTarget.removeEventListener("ended", this.handleEnded);
    }
  }
}
